import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f703b0a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3f703b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f703b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f703b0a')) {
      api.createRecord('3f703b0a', component.options)
    } else {
      api.reload('3f703b0a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f703b0a&scoped=true&", function () {
      api.rerender('3f703b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/complaint-suggestion/index.vue"
export default component.exports